import React, { useState } from "react";
import { ModalBuilder } from "@redriver/cinnamon";
import { TranslatedModal } from "features/../../../shared/components/modals";
import WarningBanner from "features/../../../shared/components/banners/WarningBanner";
import ComparisonBox from "features/Agreements/AgreementCrmComparison/ComparisonBox";
import { Button } from "semantic-ui-react";
import { submitClientCrmDetailsRequest } from "features/../../../shared/features/Clients/actions";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { requestLogout } from "features/System/Logout/actions";

const AgreementCrmCheck = ({ comparisonData, originalData, clientId }) => {
  const { t } = useTranslation("sheetTranslation"),
    tScope = "companyInfoChangeRequestModal";
  const dispatch = useDispatch();
  const [emailHasSubmitted, setEmailHasSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  return (
    <ModalBuilder
      withForm
      initialData={comparisonData.comparisonChecklist}
      renderModal={(modalProps, formProps) => (
        <TranslatedModal.Edit
          {...modalProps}
          size="large"
          header=""
          className="data-check-modal custom-actions"
        >
          {emailHasSubmitted ? (
            <div style={{ textAlign: "center", padding: 100 }}>
              <p style={{ color: "#6B036B", fontSize: 22, fontWeight: 600 }}>
                {t(`${tScope}.submission.bodyText1`)}
              </p>
              <p style={{ color: "#6B036B", fontSize: 22, fontWeight: 600 }}>
                {t(`${tScope}.submission.bodyText2`)}
              </p>
              <p style={{ color: "#000", fontSize: 14, fontWeight: 600 }}>
                {t(`${tScope}.submission.bodyText3`)}
              </p>
            </div>
          ) : (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: 10,
                paddingLeft: 25,
                paddingRight: 25,
              }}
            >
              <WarningBanner warningText={t(`${tScope}.header`)} />
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <ComparisonBox
                  header="CRM Customer Details"
                  {...formProps.value}
                  isCrm={true}
                />
                <ComparisonBox
                  header="Opal Customer Details"
                  {...formProps.value}
                  isCrm={false}
                />
              </div>
              <div style={{ marginLeft: 40 }}>
                <p style={{ margin: 0, fontWeight: 600 }}>
                  {t(`${tScope}.info.bodyText1`)}
                </p>
                <p style={{ margin: 0, fontWeight: 600 }}>
                  {t(`${tScope}.info.bodyText2`)}
                </p>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  gap: "8px",
                }}
              >
                <Button
                  primary
                  onClick={async () => {
                    await dispatch(requestLogout());
                    window.location.replace("/"); // Redirect so next login will go to the agreements page
                  }}
                >
                  {t(`${tScope}.negativeLabel`)}
                </Button>
                <Button
                  loading={isSubmitting}
                  primary
                  onClick={async () => {
                    setIsSubmitting(true);
                    const { success, response } = await dispatch(
                      submitClientCrmDetailsRequest(originalData, clientId),
                    );
                    if (success) {
                      setEmailHasSubmitted(true);
                    } else {
                      setEmailHasSubmitted(false);
                      setIsSubmitting(false);
                    }
                  }}
                >
                  {t(`${tScope}.positiveLabel`)}
                </Button>
              </div>
            </div>
          )}
        </TranslatedModal.Edit>
      )}
    />
  );
};
export default AgreementCrmCheck;
